import queries from '@apis/queries';
import Header from '@components/Header';
import { datadogRum } from '@datadog/browser-rum';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

interface Params {
    cardId: string;
}

const PrepaidCardChargeCompleteActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { cardId } = params;
  const { replace, push } = useFlow();
  const toast = useToast();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (cardId) {
      if (import.meta.env.MODE !== 'development') {
        datadogRum.addAction('prepaidChargeChargeComplete', {
          cardId,
        });
      }
      queryClient.invalidateQueries({ queryKey: queries.userPrepaidCard._def })
        .then(() => {
          replace('MainActivity', {}, { animate: false });
          push('MyPrepaidCardActivity', {});
          toast.success('선불카드 충전이 완료되었습니다.');
        }).catch(() => {
          replace('MainActivity', {}, { animate: false });
          push('MyPrepaidCardActivity', {});
          toast.error('선불카드 충전 중 오류가 발생하였습니다.');
        });
    } else {
      toast.error('선불카드 충전에 실패했습니다.');
    }
  }, [cardId]);
  return (
      <AppScreen>
          <Header title='선불카드 충전 완료' />
      </AppScreen>
  );
};

export default PrepaidCardChargeCompleteActivity;
